var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('product-model',{attrs:{"allData":_vm.productItem4,"popular_product":_vm.randomList(_vm.popular_product, 5),"header":_vm.headerMessage,"hearder_description":_vm.headerDescription,"product_header":_vm.productHeaderMessage,"item_bread_crumbs":_vm.itemsBreadCrumbs,"isLapTopCheck":_vm.isLapTopCheck}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26db3803","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/categories/racksProduct.vue
// module id = null
// module chunks = 